import React, {useEffect, useRef} from 'react';
import './LeaderboardInt.css';
import LeaderBoardTopInt from "./LeaderBoardTopInt"
import RankingInt from '../LeaderboardInt/RankingInt';
import {useHistory} from "react-router-dom";
import Slider from "react-slick";
import {useSwipeable} from "react-swipeable";
import LeaderboardBottom from "../../../../assets/images/leaderboardBottom.png";
function LeaderboardInt(props) {
    const { data, myorg, swipeActions, scrollNav } = props;
    const topData = data?.teamRankings?.slice(0, 3)
    const belowData = data?.teamRankings?.slice(3, data?.teamRankings?.length);
    const history = useHistory();
    const sliderRef = useRef(null);
    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 3000,
        appendDots: (dots) => <ul>{dots}</ul>,
        customPaging: (i) => (
            <div className="slick-indicator"></div>
        ),
    };

    const gainerSwipeActions = useSwipeable({
        onSwipedLeft: (eventData) => {
            eventData.event.stopPropagation();
        },
        onSwipedRight: (eventData) => {
            eventData.event.stopPropagation();
        },
        preventScrollOnSwipe: true,
    });

  return (
      <>

      <div className="page-content page-content-leaderBoard" {...swipeActions}>
          <div className="leader-board-table-data">
              <LeaderBoardTopInt data={topData} info={data?.info} inPage={true}/>
              <RankingInt data={belowData} myorg={myorg}/>
          </div>
          <div className="gainer-inner-box">
              <h2><span>Top 3 Educators</span> from our last campaign</h2>
              <p>and their Winnings</p>
              <div className="last-gainer-slider" {...gainerSwipeActions}>
                  <Slider {...settings} ref={sliderRef}>
                      <div className="last-gainer-box">
                          <div className="gainer-img">
                              <img src="https://cdn-cp-assets-public.classplus.co/web/courseWebview/content/repl-25-sale-winner-1.png" alt="lastgainerimg1"/>
                          </div>
                      </div>
                      <div className="last-gainer-box">
                          <div className="gainer-img">
                              <img src="https://cdn-cp-assets-public.classplus.co/web/courseWebview/content/repl-25-sale-winner-2.png" alt="lastgainerimg2"/>
                          </div>
                      </div>
                      <div className="last-gainer-box">
                          <div className="gainer-img">
                              <img src="https://cdn-cp-assets-public.classplus.co/web/courseWebview/content/repl-25-sale-winner-3.png" alt="lastgainerimg3"/>
                          </div>
                      </div>
                  </Slider>
              </div>
          </div>
          <div className="leader-board-last-box">
              <img
                  src={LeaderboardBottom}
                  onClick={() => {
                      scrollNav(1);
                      history.replace({pathname: '/tutor/details/tasks'})
                  }}
                  alt="leaderboardGiftCardPlayer"/>
          </div>
      </div>
      </>
  );
}

export default LeaderboardInt;
